
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bulk",
      function () {
        return require("private-next-pages/bulk/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bulk"])
      });
    }
  